import { render } from "./SplashText.vue?vue&type=template&id=1726d9bd&scoped=true"
import script from "./SplashText.vue?vue&type=script&lang=js"
export * from "./SplashText.vue?vue&type=script&lang=js"

import "./SplashText.vue?vue&type=style&index=0&id=1726d9bd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1726d9bd"]])

export default __exports__